import { createSlice } from '@reduxjs/toolkit';
import { showRatingInCenter, setUserRatingData, setRatingConfig } from '../actions/ratingActions';

export interface IUserRatingBase {
  Context: string;
  createdDate: string;
}

export interface IUserRatingState {
  showInCenter: boolean;
  user_Rating: IUserRatingBase[];
  ratingConfig: number;
}

const initialState: IUserRatingState = {
  showInCenter: false,
  user_Rating: [],
  ratingConfig: 0,
};

const userRatingSlice = createSlice({
  name: 'userRating',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(showRatingInCenter, (state, action) => {
      state.showInCenter = action.payload.showInCenter;
    });
    builder.addCase(setUserRatingData, (state, action) => {
      state.user_Rating = action.payload;
    });
    builder.addCase(setRatingConfig, (state, action) => {
      state.ratingConfig = action.payload;
    });
  },
});

export default userRatingSlice.reducer;
